var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('codemirror',_vm._b({model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}},'codemirror',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }